import React, {FC} from "react";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getSystemLanguageId, getUserId} from "../../../utils";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportStagnantItems} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportStagnantItemsPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: getSystemLanguageId(), userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportStagnantItems}
            searchHeader={getPageNameByPageId(PageEnum.ReportOfStagnantItems)}
            SearchPanel={ReportItemsSearchPanel}
            withDateRange={true}
            formId={PageEnum.ReportOfStagnantItems}
        />
    );
};
